<template>
  <div class="app-action-from">
    <ElCheckbox
      v-if="showAutoPublish"
      class="app-action-from__item"
      :checked="autopublish"
      @change="updateAutopublish"
    >
      {{ $t('APP.ACTIONS.AUTO_PUBLISH') }}
    </ElCheckbox>

    <ElInput
      v-if="showDeveloperNote"
      :autosize="{ minRows: 2, maxRows: 4 }"
      :placeholder="$t('DESCRIPTION')"
      :value="developerNote"
      type="textarea"
      name="developerNote"
      class="app-action-from__item"
      @input="updateDeveloperNote"
    />
  </div>
</template>

<script>
export default {
  name: 'AppActionForm',

  props: {
    actionName: {
      type: String,
      default: '',
    },
    autopublish: {
      type: Boolean,
      default: false,
    },
    developerNote: {
      type: String,
      default: '',
    },
  },

  computed: {
    showAutoPublish() {
      return (
        this.actionName === 'publish_request' ||
        this.actionName === 'suspension_removal_request'
      );
    },

    showDeveloperNote() {
      return (
        this.actionName === 'warning_removal_request' ||
        this.actionName === 'publish_request' ||
        this.actionName === 'suspension_removal_request'
      );
    },
  },

  methods: {
    updateAutopublish(value) {
      this.$emit('update:autopublish', value);
    },

    updateDeveloperNote(value) {
      this.$emit('update:developer-note', value);
    },
  },
};
</script>

<style lang="scss">
.app-action-from {
  &__item {
    margin-top: $global-margin;
  }
}
</style>
